'use client';

/**
 * Composer-surface card registry — `content_key` → React component.
 *
 * Single source of truth for "what does each composer-surface card
 * render?" Mirrors `INSIGHTS_CARD_REGISTRY`, `CANVAS_CARD_REGISTRY`,
 * `EXPLORER_CARD_REGISTRY`, `CHAT_CARD_REGISTRY` exactly — same
 * primitive, fifth surface. Adding a composer card means: one
 * `@card` decoration in `klyde_edge/composition/cards/composer.py`
 * plus one entry here.
 *
 * @see klyde_edge/composition/cards/composer.py
 * @see klyde_edge/ui_config/docs/right_rail_and_canvas_ux_direction.md
 *
 * @layer presentation
 * @arch_component_type registry
 * @arch_domain procurement
 */

import { ComposerLinesCard } from './composer-lines-card';
import { ComposerIntentCard } from './composer-intent-card';
import { ComposerProjectCard } from './composer-project-card';
import { ComposerVendorsCard } from './composer-vendors-card';
import { ComposerDatesCard } from './composer-dates-card';
import { ComposerBriefCard } from './composer-brief-card';
import { ComposerQuickChatCard } from './composer-quick-chat-card';
import { ComposerSubmitCard } from './composer-submit-card';

type ComposerCardComponent = React.ComponentType;

export const COMPOSER_CARD_REGISTRY: Record<string, ComposerCardComponent> = {
  composer_lines: ComposerLinesCard,
  composer_intent: ComposerIntentCard,
  composer_project: ComposerProjectCard,
  composer_vendors: ComposerVendorsCard,
  composer_dates: ComposerDatesCard,
  composer_brief: ComposerBriefCard,
  composer_quick_chat: ComposerQuickChatCard,
  composer_submit: ComposerSubmitCard,
};
